exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_object-pie.js
// module id = 48
// module chunks = 0